import React from "react";
import "../Style/OurTreatment.css";
import sec1 from "../Assets/sec1.png";
import skin1 from "../Assets/Skin/skin1.png";
import skin2 from "../Assets/Skin/skin2.png";
import skin3 from "../Assets/Skin/skin3.png";
import skin4 from "../Assets/Skin/skin4.png";
import skin5 from "../Assets/Skin/skin5.png";
import skin6 from "../Assets/Skin/skin6.png";
import skin7 from "../Assets/Skin/skin7.png";
import female1 from "../Assets/female/female1.png";
import female2 from "../Assets/female/female2.png";
import female3 from "../Assets/female/female3.png";
import female4 from "../Assets/female/female4.png";
import female5 from "../Assets/female/female5.png";
import female6 from "../Assets/female/female6.png";
import female7 from "../Assets/female/female7.png";
import g1 from "../Assets/general/g1.png";
import g2 from "../Assets/general/g2.png";
import g3 from "../Assets/general/g3.png";
import g4 from "../Assets/general/g4.png";
import g5 from "../Assets/general/g5.png";
import g6 from "../Assets/general/g6.png";
import g7 from "../Assets/general/g7.png";
import TreatmentCard from "./TreatmentCard";
import treat1 from "../Assets/treat1.png";
import { useAppointment } from "./AppointmentContext.js";
import BookAppointment from "./BookAppointment.js";
const OurTreatment = () => {
  const { appointmentData, handleAppointment } = useAppointment();
  const isMobile = window.innerWidth <= 768;
  const skin = {
    heading: {
      heading: "Homeopathy For Skin",
      para: "Homeopathic remedies for skin are treatments derived from the principles of homeopathy, a system of alternative medicine. In homeopathy, the idea is to treat the whole person rather than just focusing on specific symptoms. Remedies for skin conditions are formulated based on the belief that substances that cause symptoms in healthy individuals can be used in diluted forms to treat similar symptoms in individuals who are ill or suffering from skin conditions.",
    },
    content: [
      {
        imageUrl: skin1,
        name: "Warts & Moles",
        desc: "warts and moles have a broad base and go deep into the skin, but on a mole, the skin remains soft. Warts, however, appear as rough skin, possibly with points on the surface.",
        btn: "Know more",
      },
      {
        imageUrl: skin2,
        name: "Acnes, Pimples",
        desc: "Acne is a skin condition that occurs when your hair follicles become plugged with oil and dead skin cells. It causes whiteheads, blackheads or pimples.",
      },
      {
        imageUrl: skin3,
        name: "All types of Tinea",
        desc: "Tinea is a contagious fungal skin infection. The most commonly affected areas include the feet, groin, scalp. which is a misleading name as no worm is involved.",
      },
      {
        imageUrl: skin4,
        name: "Hair Fall",
        desc: "Hair loss can affect just your scalp or your entire body, and it can be temporary or permanent. It can be the result of heredity, hormonal changes, medical conditions .",
      },
      {
        imageUrl: skin5,
        name: "Alopecia",
        desc: "Sudden hair loss that starts with one or more circular bald patches that may overlap.Alopecia areata occurs when the immune system attacks hair follicles and may be brought on by severe stress.",
      },
      {
        imageUrl: skin6,
        name: "Psoriasis",
        desc: "Psoriasis is thought to be an immune system problem. Triggers include infections, stress and cold.The symptom is thick skin patches typically seen on elbows, knees, and lower back .",
      },
      {
        imageUrl: skin7,
        name: "Vitiligo, Leucoderma",
        desc: "Vitiligo occurs when pigment-producing cells die or stop functioning. Loss of skin color can affect any part of the body, including the mouth, hair and eyes.",
      },
    ],
  };
  const female = {
    heading: {
      heading: "Homeopathy For Female",
      para: "Homeopathy for females refers to the practice of using homeopathic remedies to address health issues or conditions that are specific to women. Homeopathy is a holistic system of medicine that uses highly diluted natural substances to stimulate the body’s own healing process. In the context of female health, homeopathic treatments may be used for a variety of concerns.",
    },
    content: [
      {
        imageUrl: female1,
        name: "Infertility (Male / Female)",
        desc: "Infertility is a disease of the male or female reproductive system that occurs when a couple is unable to conceive after a year or more of regular, unprotected sex",
        btn: "Know more",
      },
      {
        imageUrl: female2,
        name: "Ovarian Cyst ,PCOD",
        desc: "Ovarian cysts are fluid-filled sacs that form on or within the ovaries, while polycystic ovarian disease (PCOD) is a hormonal imbalance that can cause cysts to form on the ovaries.",
      },
      {
        imageUrl: female3,
        name: "Menses Irregularities",
        desc: "Menstrual irregularities, also known as irregular periods, are characterized by abnormal variations in the frequency, duration, or amount of menstrual bleeding.",
      },
      {
        imageUrl: female4,
        name: "Prolapse, Fibroids Uterus",
        desc: "A fibroid can prolapse into the vagina, and a prolapsed fibroid can mimic uterine inversion. tumors that grow in the uterus, and they can bulge from the inside or outside of the uterus. ",
      },
      {
        imageUrl: female5,
        name: "Leucorrhea",
        desc: "It is known as fluor albus, is a vaginal discharge that can be clear, white, yellowish, or greenish in color. It usually thin and has a mild odor, and doesn't cause itching or a strong foul smell",
      },
      {
        imageUrl: female6,
        name: "Miscarriage",
        desc: " the unexpected ending of a pregnancy in the first 20 weeks of gestation. Just because it's called a “miscarriage” doesn't mean you did something wrong in carrying the pregnancy.",
      },
      {
        imageUrl: female7,
        name: "Breast Tumor",
        desc: "tumor that grows in or around the breast tissue, mainly in the milk ducts and glands. A tumor usually its calcium deposit that develops as a result of abnormal cell growth.",
      },
    ],
  };

  const general = {
    heading: {
      heading: "General Homeopathy ",
      para: "Homeopathy is a system of alternative medicine based on the principle of like cures like. It involves using highly diluted substances, typically plant, mineral, or animal extracts, to treat various health conditions. The central idea is that these substances, when administered in small amounts, stimulate the body's natural healing abilities. Homeopathy was founded by Samuel Hahnemann in the late 18th century and emphasizes individual treatment, focusing on the person's overall physical, mental, and emotional state. It operates under the belief that symptoms of illness are a reflection of an underlying imbalance within the body that can be corrected by matching the right remedy.",
    },
    content: [
      {
        imageUrl: g1,
        name: "Cervical, Lumber  Spondylitis and  Spondylosis",
        desc: "The neck, or to the neck of any organ or structure. Cervical lymph nodes  Cervical cancer refers to cancer of the uterine cervix, which is the lower, narrow end of the uterus.",
        btn: "Know more",
      },
      {
        imageUrl: g2,
        name: "Kidney Diseases",
        desc: " kidneys are damaged and can't filter blood the way they should. You are at greater risk for kidney disease. If you experience kidney failure, treatments include kidney transplant or dialysis.",
      },
      {
        imageUrl: g3,
        name: "Kidney Stone",
        desc: "Kidney stones are hard, pebble-like pieces of material that form in one or both of your kidneys when high levels of certain minerals are in your urine.",
      },
      {
        imageUrl: g4,
        name: "G.Bladder Stone",
        desc: "Gallstones are hardened deposits of digestive fluid, called bile, that form in the gallbladder. They can range in size from a grain of sand to a golf ball. ",
      },
      {
        imageUrl: g5,
        name: "Liver Diseases",
        desc: "Liver disease is a general term for conditions that prevent the liver from functioning properly. The liver is a large organ that performs many vital functions",
      },
      {
        imageUrl: g6,
        name: "Paralysis",
        desc: " Paralysis is the loss of muscle function in some or all of the body, which can be temporary or permanent. It occurs when the messages between the brain and muscles are disrupted",
      },
      {
        imageUrl: g7,
        name: "Prostate Enlargement",
        desc: "Prostate enlargement, also known as benign prostatic hyperplasia (BPH), is a condition where the prostate gland increases in size. It's a common condition that affects many men",
      },
    ],
  };
  return (
    <div className="our-treatment-container">
      <h1 className="our-treatments-h1">Our Treatments</h1>
      <p className="treat-para">
        At{" "}
        <b style={{ color: "var(--primary-color)" }}>
          Homeopathy Healthcare and Research Center
        </b>
        , we offer a wide range of homeopathic treatments designed to help you
        achieve balance and wellness in a natural and holistic way. Our team of
        experienced homeopaths is dedicated to providing personalized care,
        targeting the root causes of health issues rather than just alleviating
        symptoms. Homeopathy is a safe, gentle, and effective approach to
        healing, suitable for individuals of all ages.
      </p>
      <div className="treat-sec-2">
        <h1 style={{ textAlign: isMobile ? "center" : "left" }}>
          What is Homeopathy?
        </h1>
        <p className="treat-para" style={{ marginTop: "10px" }}>
          Homeopathy is a natural healing system based on the principle of "like
          cures like." This means that substances that cause symptoms in a
          healthy person can, in very small doses, treat similar symptoms in a
          sick person. Homeopathic treatments stimulate your body’s own healing
          abilities, helping restore balance and overall health.
        </p>
      </div>
      <div className="treat-sec-3">
        <div className="treat-sec-2-content">
          <TreatmentCard skin={skin} />
        </div>
        <div className="treat-sec-2-content">
          <TreatmentCard skin={female} />
        </div>
        <div className="treat-sec-2-content">
          <TreatmentCard skin={general} />
        </div>
      </div>
      <div className="treat-sec-4">
        <div className="treat-sec-4-1">
          <h1 style={{ fontSize: isMobile ? "30px" : "" }}>
            How Does a Homeopathic Consultation Work?
          </h1>
          <p className="sec4-p">
            Your health journey starts with a comprehensive consultation where
            we take the time to understand your unique symptoms, medical
            history, lifestyle, and emotional state. Based on this information,
            we’ll recommend a customized homeopathic treatment plan.
          </p>
          <h2>The Process includes:</h2>
          <ol className="treat-ol">
            <li>
              <b style={{ color: "black" }}>Initial Consultation</b>:{" "}
              <span style={{ color: "var(--primary-color)" }}>
                Detailed discussion about your health concerns, lifestyle, and
                medical history.
              </span>
            </li>
            <li>
              <b style={{ color: "black" }}>Remedy Selection</b>:{" "}
              <span style={{ color: "var(--primary-color)" }}>
                Based on your individual needs, we select the most suitable
                remedies.
              </span>
            </li>
            <li>
              <b style={{ color: "black" }}>Follow-Up</b>:{" "}
              <span style={{ color: "var(--primary-color)" }}>
                Regular check-ins to monitor your progress and make adjustments
                to your treatment as necessary.
              </span>
            </li>
          </ol>
        </div>
        <div className="treat-sec-4-2">
          <img src={treat1} />
        </div>
      </div>
      <div
        style={{
          color: "var(--primary-color)",
          textAlign: "center",
          fontSize: "18px",
          marginTop: "40px",
        }}
      >
        <b>
          Our goal is to work in partnership with you, ensuring that your health
          and wellness are fully supported through every step of your journey.
        </b>
      </div>
      <div className="treat-sec-5">
        <h1 style={{ fontSize: isMobile ? "29px" : "" }}>
          Why Choose Homeopathy?
        </h1>
        <p className="sec4-p">
          Your health journey starts with a comprehensive consultation where we
          take the time to understand your unique symptoms, medical history,
          lifestyle, and emotional state. Based on this information, we’ll
          recommend a customized homeopathic treatment plan.
        </p>
        <ol className="treat-ol">
          <li>
            <b style={{ color: "black" }}>Natural & Safe</b>:{" "}
            <span style={{ color: "var(--primary-color)" }}>
              Homeopathic remedies are made from natural substances, making them
              safe for individuals of all ages.
            </span>
          </li>
          <li>
            <b style={{ color: "black" }}>Non-Invasive</b>:{" "}
            <span style={{ color: "var(--primary-color)" }}>
              We offer gentle treatments that support your body’s healing
              processes.
            </span>
          </li>
          <li>
            <b style={{ color: "black" }}>Individualized Care</b>:{" "}
            <span style={{ color: "var(--primary-color)" }}>
              Every person is unique, and our treatments are tailored to suit
              your specific needs and goals.
            </span>
          </li>
          <li>
            <b style={{ color: "black" }}>No Side Effects</b>:{" "}
            <span style={{ color: "var(--primary-color)" }}>
              Homeopathic remedies have no harmful side effects, making them
              ideal for long-term health management.
            </span>
          </li>
        </ol>
      </div>
      <div className="treat-last-sec">
        <h1 style={{ fontSize: isMobile ? "26px" : "" }} >
          Book Your Appointment
        </h1>
        <p className="sec4-p" style={{ marginTop: "30px" }}>
          If you’re ready to start your healing journey or would like to learn
          more about our homeopathic treatments, we’re here to help. Book your
          consultation today and experience the benefits of holistic health
          care.
        </p>
        <button className="treat-btn" onClick={handleAppointment}>BOOK APPOINTMENT</button>
      </div>
      {appointmentData && (
        <div className="popup-overlay" onClick={handleAppointment}>
          <BookAppointment handleAppointment={handleAppointment} />
        </div>
      )}
    </div>
  );
};

export default OurTreatment;
